import React, {Component} from 'react';
import {Navbar, Nav, NavItem, NavDropdown, MenuItem} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import {LinkContainer} from 'react-router-bootstrap';
import Navigation from './Navigation';
import HeaderComponent from './Header';

import style from './style.less';
import './style.less';

export default class Header extends Component {
	render() {
		return (
			<Navbar collapseOnSelect fluid={true} fixedTop>
				<Navbar.Header className={style.header}>
					<HeaderComponent/>
					<Navbar.Toggle/>
				</Navbar.Header>
				<Navbar.Collapse className={style.navbarcustom}>
					<Navigation/>
				</Navbar.Collapse>
			</Navbar>
		);
	}
}



// WEBPACK FOOTER //
// ./components/header/index.js